import { defineStore } from "pinia";
import Services from '@/services/sutting/collegesServices'
import { mapList2Level, mapList, mapCollege } from '@/helpers/mapFuncs'

export const useCollegesStore = defineStore("colleges", {
persist: true,
state:()=>({
    college: {},
    colleges: [],
}),
getters : {
    getCollege() {
        return mapCollege(this.college)
    },
    getColleges() {
        return this.colleges.map(mapCollege)
    },
    getCollegesList() {
        return this.colleges.map(mapList)
    },
    getCollegesList2Level() {
        return this.colleges.map(mapList2Level)
    }
},
actions : {
    /** Start Sets */
    setCollege(college) {
        this.college = college
    },
    setColleges(colleges) {
        this.colleges = colleges
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setCollege(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setColleges(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.colleges.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.colleges[this.colleges.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.colleges = this.colleges.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
